import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'stepsSummary'
	| 'thinkingCompleted'
	| 'rovoIsThinking'
	| 'collapse'
	| 'thinkDeeperThinking'
	| 'executeBashSubstep';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		stepsSummary: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.steps-summary',
			defaultMessage: 'Completed {total} steps',
			description:
				'Step summary text displayed in a compact research steps component within the AI conversation interface, showing the total number of completed steps in a research process. Shown as text in a step indicator. The total placeholder will be substituted with the total number of steps (e.g., "Completed 5 steps"). The purpose is to help users understand the total number of steps completed in the research process.',
		},
		thinkingCompleted: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.thinking-completed',
			defaultMessage: 'Thinking completed',
			description:
				'Step summary text displayed in a compact research steps component within the AI conversation interface when only a single step was completed. The purpose is to inform users that the AI has finished its thinking process.',
		},
		rovoIsThinking: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.rovo-is-thinking',
			defaultMessage: 'Rovo is thinking',
			description:
				'Status message text displayed in a compact research steps component within the AI conversation interface when Rovo (the AI assistant) is processing a research request and generating a response. Shown as text in a loading state indicator. The purpose is to inform users that the AI is actively working on their research request and will respond shortly, providing feedback during the wait time.',
		},
		collapse: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.collapse',
			defaultMessage: 'Collapse',
			description:
				'Button label or action text displayed on a button or clickable element in a compact research steps component within the AI conversation interface that collapses to hide detailed step information. Shown as clickable text on a collapse/expand control. When clicked, it collapses the research steps to show only a summary. The purpose is to allow users to minimize the research steps display to save screen space and reduce visual clutter.',
		},
		thinkDeeperThinking: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.think-deeper-thinking',
			defaultMessage: 'Thinking deeply and analyzing',
			description: 'The message displayed for think deeper thinking',
		},
		executeBashSubstep: {
			id: 'ai-mate.rovo-platform-ui-components.compact-research-steps.execute-bash-substep',
			defaultMessage: 'Writing and executing code',
			description:
				"Substep preview text shown for trace steps emitted by the execute_bash tool, indicating Rovo is writing and executing a bash command on the user's behalf. Replaces the raw command/output snippet to keep the trace readable. Also rendered as the first substep when the trace is expanded.",
		},
	});

export default message;
